const rootUrl = 'https://vesapa.com';
const api = 'vesapa.com';
export const environment = {
    onesignalId: '37786b7e-7896-4b33-a752-7288059a41c3',
    firebaseId: '223261551303',
    root: rootUrl,
    evn: 'pro',
    api: api,
    access_token: api + '_access_token',
    forgot_key: api + '_forgot_key',
    production: false,
    login: rootUrl + '/api/users/login',
    register: rootUrl + '/api/users/register',
    forgotPassword: rootUrl + '/api/users/forgotpassword',
    resetPassword: rootUrl + '/api/users/resetpassword',
    changePassword: rootUrl + '/api/users/changepassword',
    renewToken: rootUrl + '/api/users/renewtoken',


    content: rootUrl + '/api/users/contents',
    project: rootUrl + '/api/users/projects',
    buy_customer: rootUrl + '/api/users/buycustomers',
    customers: rootUrl + '/api/users/customers',
    address: rootUrl + '/api/users/address',
    status: rootUrl + '/api/users/status',
    notes: rootUrl + '/api/users/notes',
    revenue: rootUrl + '/api/users/revenue',
    reports: rootUrl + '/api/users/reports',
    history: rootUrl + '/api/users/history',
    statictis: rootUrl + '/api/users/statictis',
    home: rootUrl + '/api/users/home',
    config: rootUrl + '/api/users/config',
    notify: rootUrl + '/api/users/notify',
    notifydetail: rootUrl + '/api/users/notifydetail',
    cdocument: rootUrl + '/api/users/cdocument',
    documents: rootUrl + '/api/users/documents',
    add_request: rootUrl + '/api/users/addrequest',
    received: rootUrl + '/api/users/received',
    request: rootUrl + '/api/users/requests',
    shopcategory: rootUrl + '/api/users/shopcategories',
    shopproducts: rootUrl + '/api/users/shopproducts',
    shopproductdetail: rootUrl + '/api/users/shopproductdetail',
    shoporders: rootUrl + '/api/users/shoporders',
    shoporderdetail: rootUrl + '/api/users/shoporderdetail',
    shopaddress: rootUrl + '/api/users/shopaddress',
    shopcountry: rootUrl + '/api/users/shopcountry',
    shopzone: rootUrl + '/api/users/shopzone',
    updateaddress: rootUrl + '/api/users/shopupdateaddress',
    removeaddress: rootUrl + '/api/users/shopremoveaddress',
    payment: rootUrl + '/api/users/shoppayment',
    checkout: rootUrl + '/api/users/shopcheckout',
    checkstatus: rootUrl + '/api/users/checkstatus',
    viewed: rootUrl + '/api/users/shopviewed',
    shop_default_address: rootUrl + '/api/users/shopdefaultaddress',
    coupon: rootUrl + '/api/users/shopcoupon',
    voucher: rootUrl + '/api/users/shopvoucher',
    user_info: rootUrl + '/api/users/info',
    order_status: rootUrl + '/api/users/shoporderstatus',
    update_order: rootUrl + '/api/users/shopupdateorder',
    report_order: rootUrl + '/api/users/shopreportorders',
    report: rootUrl + '/api/users/shopreport',
    admin_stock: rootUrl + '/api/users/shopstockuser',
    bookform: rootUrl + '/api/users/bookform',
    book: rootUrl + '/api/users/book',
    shipping_fee: rootUrl + '/api/users/shopshipghtk',
    payment_status: rootUrl + '/api/users/shoppaymentstatus',
    cancel_order: rootUrl + '/api/users/shopcancelorder',
    shippingfee: rootUrl + '/api/users/shopshippingfee',
    shopcampaign: rootUrl + '/api/users/shopcampaign',
    stock: rootUrl + '/api/users/stock',
    synccart: rootUrl + '/api/users/synccart',
    extra: rootUrl + '/api/users/extra',
    wishlist: rootUrl + '/api/users/shopwishlist',
    add_wishlist: rootUrl + '/api/users/addwishlist',
    remove_wishlist: rootUrl + '/api/users/removewishlist',
    ticket: rootUrl + '/api/users/ticket',

    onepay: rootUrl + '/index.php?option=com_eshop&task=payment.makePayment'
};
export const enum PageOptions {
    LOGIN_PAGE = 'LoginPage',
    HOME_PAGE = 'WelcomePage',
    LOGIN_REDIRECT = 'AccountPage'

}



// WEBPACK FOOTER //
// ./src/environments/environment.ts